import $ from 'jquery'

import { button } from '../../../../../component/component'

import * as timecode from '../../../../../lib/timecode'

export default function(o,c){

  var token = o.store('token')
  
  var thumbServer = o.store('thumbServer')
  var videoServer = o.store('videoServer')

  var click = function(){

    var x = div.offset().left + div.outerWidth()
    var y = div.offset().top

    var generateDownloadButton = function(quality){

      if(o.roll){
        if(o.store('role') == "admin"){
          var download = `omb_${o.roll}_${quality}.mp4`
          var href = `${videoServer}download/archive/${quality}/${download}?token=${token}`
        } else {
          var download = `omb_${o.roll}_${quality}_wm.mp4`
          var href = `${videoServer}downloadWatermark/${quality}/${download}?token=${token}`
        }
      } else {
        var download = o.sequence.files[quality]
        var href = `${videoServer}download/sequence/${quality}/${download}?token=${token}`
      }

      var downloadButton =
        $('<a>')
        .append(
          button(quality,'fi-download')
          .css({
            display: 'block',
          })
        )
        .attr({
          download: download,
          href: href,
        })
        .css({
          textDecoration: 'none',
        })
        .click(
          function(){
            menu.remove()
          }
        )

      return downloadButton

    }

    var generateScreenshotButton = function(){

      var start = timecode.toSmtp(o.loopStart)

      if(o.store('role') == 'admin'){
        var href = `${thumbServer}downloadScreenshot/?roll=${o.roll}&start=${start}&token=${token}`
      } else {
        var href = `${thumbServer}downloadScreenshotWatermark/?roll=${o.roll}&start=${start}&token=${token}`
      }

      var screenshotButton =
        $('<a>')
        .append(
          button('still','fi-camera')
          .css({
            display: 'block',
          })
        )
        .attr({
          href: href,
          download: true,
        })
        .css({
          textDecoration: 'none',
        })
        .click(function(){
          console.log('screenshot', o.roll, o.loopStart, href)
          menu.remove()
        })

      return screenshotButton

    }

    var overlay =
      $('<div>')
      .css({
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.5)',
      })
      .click(function(){
        menu.remove()
      })

    var buttons =
      $('<div>')
      .css({
        position: 'absolute',
        left: x,
        top: y,
      })

    if(Config.resolutions[360]){
      buttons.append([generateDownloadButton('360')])
    }

    if(Config.resolutions[480]){
      buttons.append([generateDownloadButton('480')])
    }

    if(Config.resolutions[720]){
      buttons.append([generateDownloadButton('720')])
    }

    if(Config.resolutions[1080]){
      buttons.append([generateDownloadButton('1080')])
    }

    if(o.roll){
      buttons.append([generateScreenshotButton()])
    }

    var menu =
      $('<div>')
      .css({
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      })
      .append([
        overlay,
        buttons,
      ])

    $('body')
    .append(menu)
    // downloadRoll(o,quality)

  }

  var div =
    button(null,'fi-download')
    .css({
      position: 'absolute',
      right: 0,
      top: 0,
    })
    .click(click)

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/controls/buttons/download/download.js